import i18n from 'i18next';

import type {} from '../interfaces/i18n';

//import en from '@/data/languages/en.json';
//import es from '@/data/languages/es.json';

import { initReactI18next } from 'react-i18next';

export const resources = {
  es: { translation: {} },
  en: { translation: {} }
} as const;

const userLang = navigator.language.split('-')[0] || 'es';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: userLang, // Establece el idioma inicial
    //lng: 'en',
    fallbackLng: 'es', // Si el idioma no está soportado, usa español
    interpolation: { escapeValue: false }
  });

/**
 * Función para actualizar dinámicamente los recursos de idioma.
 */
export const updateI18nLanguage = (lng: string, resources: Record<string, any>) => {
  i18n.changeLanguage(lng);
  i18n.addResourceBundle(lng, 'translation', resources, true, true);
};

export default i18n;
